import { render, staticRenderFns } from "./SoldOutAlert.vue?vue&type=template&id=3eab03e7&"
import script from "./SoldOutAlert.vue?vue&type=script&lang=ts&"
export * from "./SoldOutAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SoldOutAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eab03e7')) {
      api.createRecord('3eab03e7', component.options)
    } else {
      api.reload('3eab03e7', component.options)
    }
    module.hot.accept("./SoldOutAlert.vue?vue&type=template&id=3eab03e7&", function () {
      api.rerender('3eab03e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Availability/view/vue/components/SoldOutAlert.vue"
export default component.exports